import React from "react";
import { BiLinkExternal } from "react-icons/bi";
import IMG1 from "../../assets/proto_create.jpg";
import IMG2 from "../../assets/wp6631294.webp";
import IMG3 from "../../assets/petopia.png";
import IMG4 from "../../assets/project-buscaminas.jpeg"
import IMG5 from "../../assets/project-tesla.png";
import IMG6 from "../../assets/project-disney+.jpg";

const Portfolio = () => {
  const data = [
    {
      id: 6,
      image: IMG6,
      title: "Disney+ Clone",
      github: "https://github.com/RomiMolina/disneyplus-clone",
      demo: "https://disneyplus-clone-olive-rho.vercel.app/",
    },
    {
      id: 5,
      image: IMG5,
      title: "TeslaWeb Clone",
      github: "https://github.com/RomiMolina/tesla_project",
      demo: "https://tesla-project-teal.vercel.app/",
    },
    {
      id: 4,
      image: IMG4,
      title: "Booscaminas 2.6",
      github: "https://github.com/RomiMolina/Booscaminas2.6",
      demo: "https://booscaminas2-6.vercel.app/",
    },
    {
      id: 3,
      image: IMG3,
      title: "Fundación Animal",
      github: "https://github.com/RomiMolina/FE-Shelter",
      demo: "https://fe-shelter.vercel.app/",
    },
    {
      id: 2,
      image: IMG1,
      title: "PI Pokemons",
      github: "https://github.com/RomiMolina/ProyectoPokemons",
      demo: "",
    },
    {
      id: 1,
      image: IMG2,
      title: "Rick and Morty App",
      github: "https://github.com/RomiMolina/ProyectoPokemons",
      demo: "",
    },
  ];

  return (
    <section id="portfolio" className="py-16 bg-white">
      <h5 className="text-title">My recent work</h5>
      <h2 className="text-subtitle">Portfolio</h2>
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {data.map((item) => (
          <article
            key={item.id}
            className="bg-white border border-gray-300 rounded-lg shadow-md overflow-hidden transition duration-300 ease-in-out hover:bg-pink-100 hover:border-primary"
          >
            <div className="relative h-64 overflow-hidden">
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="text-primary text-center text-xl font-bold my-4">{item.title}</h3>
            <div className="flex justify-center mb-6">
              <a
                href={item.github}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-primary text-white py-2 px-4 rounded-md border
                 border-aqua font-semibold text-center mr-4 hover:bg-dark"
              >
                GitHub
              </a>
              {item.demo && (
                <a
                  href={item.demo}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-transparent text-primary py-2 px-4 rounded-md border border-primary font-semibold text-center flex items-center hover:bg-light"
                >
                  Live Demo <BiLinkExternal className="ml-2" />
                </a>
              )}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
